/**
 * @generated SignedSource<<ff7cb123500a5944245c978cd3f43bef>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MeetingFeedbackSettingChoices = "ANONYMOUS" | "PROMPT" | "TAB";
export type StreamSettingsSetMeetingFeedbackMutation$variables = {
  setting: MeetingFeedbackSettingChoices;
  streamId: string;
  value: boolean;
};
export type StreamSettingsSetMeetingFeedbackMutation$data = {
  readonly noteStreamSetMeetingFeedbackSetting: {
    readonly stream: {
      readonly isMeetingFeedbackAnonymous: boolean;
      readonly isMeetingFeedbackPromptEnabled: boolean;
      readonly isMeetingFeedbackTabEnabled: boolean;
      readonly tabs: ReadonlyArray<{
        readonly icon: string | null;
        readonly id: string;
        readonly isEmbedded: boolean;
        readonly order: number;
        readonly otherStreamId: string | null;
        readonly title: string;
        readonly url: string | null;
      }>;
    };
  } | null;
};
export type StreamSettingsSetMeetingFeedbackMutation = {
  response: StreamSettingsSetMeetingFeedbackMutation$data;
  variables: StreamSettingsSetMeetingFeedbackMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "setting"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "streamId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "value"
},
v3 = [
  {
    "kind": "Variable",
    "name": "setting",
    "variableName": "setting"
  },
  {
    "kind": "Variable",
    "name": "streamId",
    "variableName": "streamId"
  },
  {
    "kind": "Variable",
    "name": "value",
    "variableName": "value"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMeetingFeedbackTabEnabled",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMeetingFeedbackPromptEnabled",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isMeetingFeedbackAnonymous",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "concreteType": "NoteStreamTabNode",
  "kind": "LinkedField",
  "name": "tabs",
  "plural": true,
  "selections": [
    (v7/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "otherStreamId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "order",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isEmbedded",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "StreamSettingsSetMeetingFeedbackMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "NoteStreamSetMeetingFeedbackSetting",
        "kind": "LinkedField",
        "name": "noteStreamSetMeetingFeedbackSetting",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "stream",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "StreamSettingsSetMeetingFeedbackMutation",
    "selections": [
      {
        "alias": null,
        "args": (v3/*: any*/),
        "concreteType": "NoteStreamSetMeetingFeedbackSetting",
        "kind": "LinkedField",
        "name": "noteStreamSetMeetingFeedbackSetting",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "NoteStream",
            "kind": "LinkedField",
            "name": "stream",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v8/*: any*/),
              (v7/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e7b7bb4ac397d1587b5080c1da11de03",
    "id": null,
    "metadata": {},
    "name": "StreamSettingsSetMeetingFeedbackMutation",
    "operationKind": "mutation",
    "text": "mutation StreamSettingsSetMeetingFeedbackMutation(\n  $streamId: ID!\n  $setting: MeetingFeedbackSettingChoices!\n  $value: Boolean!\n) {\n  noteStreamSetMeetingFeedbackSetting(streamId: $streamId, setting: $setting, value: $value) {\n    stream {\n      isMeetingFeedbackTabEnabled\n      isMeetingFeedbackPromptEnabled\n      isMeetingFeedbackAnonymous\n      tabs {\n        id\n        otherStreamId\n        icon\n        title\n        order\n        isEmbedded\n        url\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "8dff8e8f4f17ac62828e9a3463ae1162";

export default node;
